import isStrongPassword from "validator/lib/isStrongPassword";

export const passwordValidator = (value: string) => isStrongPassword(value);